import React from "react";
import ContentCard from "../../../../UI/ContentCard/ContentCard";

import start1Img from "../../../../assests/images/start1.png";
import start3Img from "../../../../assests/images/start3.png";

const Start = () => (
  <ContentCard
    title="THE Start"
    id="start"
    image={start1Img}
    imageTtitle="How We Started"
    frontText="We decided to launch with a self coded website and perfectly constructed products."
    backTextOne="We decided to launch with a self coded website and perfectly constructed products in the area of casual wear and beach wear. We want for the customer to have the maximum choice in style and design. We decided to do hoodies, jackets, vests, body wraps, towels and beach towels.  After our launch we will ask the SAMPELL community what the next products should be."
    imageBack1={start1Img}
    imageTitle1="The Ground"
    imageBack2={start3Img}
    imageTitle2="La Turbine"
    caption="In the last months we focused on getting everything together from the production line to logistics and legal issues to the website. So we work at co-working spaces in Mauritius, like in THE GROUND (left) and La Turbine (right) as well as from Germany."
  />
);

export default Start;



// WEBPACK FOOTER //
// ./src/components/Pages/Progress/Content/Start.js